import { OverlayRef } from '@angular/cdk/overlay';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Profile } from 'src/app/data/models/interfaces/profile.interface';
import { ProfileService } from 'src/app/data/services/profile.service';
import { ImageItem } from '../select-simple-list/model/item-image.interface';

@Component({
  selector: 'app-profile-select',
  templateUrl: './profile-select.component.html',
  styleUrls: ['./profile-select.component.scss'],
})
export class ProfileSelectComponent implements OnInit, OnChanges {
  @Output() selectEvent = new EventEmitter<string[]>();

  @Input() initialIds: string[] = [];
  @Input() allProfiles = false;

  selectedIdsProfiles: string[] = [];
  readonly filterText = 'Selecione o Perfil';
  profilesSelectAllText = 'Marcar/Desmarcar todos';
  selectedFilterText = this.filterText;
  profilesList: ImageItem[] = [];

  isOpen = false;

  constructor(private profilesService: ProfileService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialIds) {
      if (this.profilesList.length > 0) {
            this.applyInitialState(changes.initialIds.currentValue);
      } else {
            this.selectedIdsProfiles = changes.initialIds.currentValue;
        }
    }
  }

  ngOnInit(): void {
    this.loadProfiles();
  }

  handleProfileSelect(profiles: ImageItem[]): void {
    this.isOpen = false;
    const selectedProfiles = profiles.filter((item) => item.isChecked);
    const ids = selectedProfiles.map((evt) => evt.id);
    this.selectedIdsProfiles = ids as string[];
    const selectedProfilesText = this.formatSelectedProfilesText(profiles);
    this.selectedFilterText = selectedProfilesText
      ? selectedProfilesText
      : this.filterText;

    this.selectEvent.emit(this.selectedIdsProfiles);
    this.initialIds = this.selectedIdsProfiles;
  }

  private formatSelectedProfilesText(profiles: ImageItem[]): string {
    const countCheckedProfiles = profiles.filter(
      (profile) => profile.isChecked
    ).length;
    let profilesText = '';
    if (countCheckedProfiles >= 1) {
      profilesText = profiles.filter((profile) => profile.isChecked)[0].name;
      if (countCheckedProfiles > 1) {
        profilesText = profilesText
          .concat(' +')
          .concat((countCheckedProfiles - 1).toString());
      }
    }
    return profilesText;
  }

  private loadProfiles() {
    this.profilesService
      .getAll()
      .toPromise()
      .then((profiles) => {
        if (profiles && profiles.length > 0) {
          this.profilesList = [];
          if (!this.allProfiles) {
            this.profilesList.push(
              ...profiles
                .filter((p) => p.name.substring(0, 11) == 'Responsável')
                .map(this.mapImageItems)
            );
          } else {
            this.profilesList.push(...profiles.map(this.mapImageItems));
          }
          this.applyInitialState(this.initialIds);
        }
      });
  }

  private applyInitialState(initialIds: string[]): void {
    if (initialIds.length === 0) {
        this.selectedIdsProfiles = [];
        this.selectedFilterText = this.filterText;
        this.profilesList.forEach((p) => (p.isChecked = false));
        return;
    }
    this.profilesList.forEach((el) => {
        el.isChecked = initialIds.includes(el.id!);
    });
    this.selectedFilterText = this.formatSelectedProfilesText(this.profilesList);
    this.selectedIdsProfiles = initialIds;
  }

  private mapImageItems = (profile: Profile) => ({
    id: profile.id,
    imageUrl: '',
    name: profile.name,
    isChecked: this.selectedIdsProfiles.includes(profile.id!)!,
  });
}
